import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { NgIf } from '@angular/common';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-title',
  templateUrl: './bary-input-title.component.html',
  styleUrls: ['./bary-input-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MDBBootstrapModulesPro, ReactiveFormsModule, MarkAsteriskDirective, NgIf, BaryIconComponent],
})
export class BaryInputTitleComponent implements OnInit {
  @Input() id = '';
  @Input() control = new FormControl('');
  @Input() maxlength: number = 250;

  @ViewChild('inputTitle') inputTitle!: ElementRef;

  protected isBeingModified = false;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    this.id = this.id ? this.id : BaryComponentHelper.makeId();
  }

  get value(): string {
    return this.control.value ?? '';
  }

  public toModify(): void {
    this.isBeingModified = true;
    setTimeout(() => {
      // Use setTimeout to ensure the input is rendered
      if (this.inputTitle) {
        this.inputTitle.nativeElement.focus();
      }
    }, 0);
  }
}
